import React, { useState, useEffect } from "react";

// Añadimos 'alCerrarSesion' en las props del componente
function PanelAdmin({ alVolver, alCerrarSesion }) {
  const [anuncios, setAnuncios] = useState([]);
  const [usuarios, setUsuarios] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [pestanaActiva, setPestanaActiva] = useState("usuarios");

  const cargarPendientes = async () => {
    try {
      const res = await fetch(
        "https://micontenidohot.com/obtener_pendientes.php"
      );
      const data = await res.json();
      if (data.success) {
        setAnuncios(data.anuncios || []);
        setUsuarios(data.usuarios || []);
      }
    } catch (err) {
      console.error("Error al cargar pendientes:", err);
    } finally {
      setCargando(false);
    }
  };

  useEffect(() => {
    cargarPendientes();
  }, []);

  const manejarAccion = async (id, accion) => {
    try {
      const res = await fetch("https://micontenidohot.com/admin_acciones.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id, accion }),
      });
      const data = await res.json();
      alert(data.mensaje);
      if (data.success) {
        cargarPendientes();
      }
    } catch (err) {
      alert("Error al conectar con el servidor.");
    }
  };

  if (cargando) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          backgroundColor: "#090d16",
          color: "#fff",
          fontSize: "1.2rem",
          fontWeight: "500",
        }}
      >
        <div style={{ textAlign: "center" }}>
          <div
            style={{
              marginBottom: "15px",
              fontSize: "2rem",
              animation: "pulse 1.5s infinite",
            }}
          >
            ⚙️
          </div>
          Cargando Panel de Control...
        </div>
      </div>
    );
  }

  return (
    <div
      style={{
        minHeight: "100vh",
        width: "100%",
        backgroundColor: "#090d16",
        color: "#f8fafc",
        fontFamily: "system-ui, -apple-system, sans-serif",
        padding: "24px",
        boxSizing: "border-box",
      }}
    >
      {/* HEADER OPTIMIZADO */}
      <header
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          paddingBottom: "20px",
          borderBottom: "1px solid #1e293b",
          marginBottom: "30px",
          flexWrap: "wrap",
          gap: "16px",
        }}
      >
        <div>
          <h2
            style={{
              color: "#ff2c55",
              margin: 0,
              fontSize: "1.75rem",
              fontWeight: "800",
              letterSpacing: "-0.025em",
            }}
          >
            ⚙️ Control Center
          </h2>
          <p
            style={{
              color: "#94a3b8",
              margin: "4px 0 0 0",
              fontSize: "0.875rem",
            }}
          >
            Panel de verificación global de Passion.com
          </p>
        </div>

        {/* BOTONES LATERALES EN MODO SUAVE */}
        <div style={{ display: "flex", gap: "10px" }}>
          <button
            onClick={alVolver}
            style={{
              padding: "10px 18px",
              background: "#1e293b",
              color: "#cbd5e1",
              border: "1px solid #334155",
              borderRadius: "12px",
              cursor: "pointer",
              fontWeight: "600",
              fontSize: "0.85rem",
              transition: "all 0.2s ease",
              display: "flex",
              alignItems: "center",
              gap: "6px",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = "#334155";
              e.currentTarget.style.color = "#fff";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = "#1e293b";
              e.currentTarget.style.color = "#cbd5e1";
            }}
          >
            <span>←</span> Volver a la App
          </button>

          {/* BOTÓN CERRAR SESIÓN SUAVE */}
          <button
            onClick={alCerrarSesion}
            style={{
              padding: "10px 18px",
              background: "rgba(244, 63, 94, 0.1)",
              color: "#f43f5e",
              border: "1px solid rgba(244, 63, 94, 0.2)",
              borderRadius: "12px",
              cursor: "pointer",
              fontWeight: "600",
              fontSize: "0.85rem",
              transition: "all 0.2s ease",
              display: "flex",
              alignItems: "center",
              gap: "6px",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = "rgba(244, 63, 94, 0.2)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = "rgba(244, 63, 94, 0.1)";
            }}
          >
            <span>🚪</span> Cerrar Sesión
          </button>
        </div>
      </header>

      {/* TABS SELECTORAS */}
      <div
        style={{
          display: "flex",
          gap: "12px",
          marginBottom: "24px",
          borderBottom: "1px solid #1e293b",
          paddingBottom: "12px",
        }}
      >
        <button
          onClick={() => setPestanaActiva("usuarios")}
          style={{
            padding: "10px 18px",
            borderRadius: "10px",
            border: "none",
            fontWeight: "600",
            cursor: "pointer",
            fontSize: "0.9rem",
            background:
              pestanaActiva === "usuarios" ? "#ff2c55" : "transparent",
            color: pestanaActiva === "usuarios" ? "#fff" : "#94a3b8",
            transition: "all 0.3s",
          }}
        >
          👥 Cuentas de Usuarios ({usuarios.length})
        </button>
        <button
          onClick={() => setPestanaActiva("anuncios")}
          style={{
            padding: "10px 18px",
            borderRadius: "10px",
            border: "none",
            fontWeight: "600",
            cursor: "pointer",
            fontSize: "0.9rem",
            background:
              pestanaActiva === "anuncios" ? "#ff2c55" : "transparent",
            color: pestanaActiva === "anuncios" ? "#fff" : "#94a3b8",
            transition: "all 0.3s",
          }}
        >
          📝 Anuncios Nuevos ({anuncios.length})
        </button>
      </div>

      {/* CONTENEDOR PRINCIPAL */}
      <main style={{ width: "100%" }}>
        {/* SECCIÓN USUARIOS */}
        {pestanaActiva === "usuarios" && (
          <section>
            {usuarios.length === 0 ? (
              <div
                style={{
                  textAlign: "center",
                  padding: "60px 20px",
                  background: "#0f172a",
                  borderRadius: "16px",
                  border: "1px dashed #334155",
                }}
              >
                <p style={{ color: "#64748b", fontSize: "1rem", margin: 0 }}>
                  🎉 Excelente. No quedan usuarios esperando verificación de
                  edad.
                </p>
              </div>
            ) : (
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fill, minmax(320px, 1fr))",
                  gap: "20px",
                }}
              >
                {usuarios.map((user) => (
                  <div
                    key={user.id}
                    style={{
                      background: "#0f172a",
                      padding: "20px",
                      borderRadius: "16px",
                      border: "1px solid #1e293b",
                      display: "flex",
                      flexDirection: "column",
                      boxShadow: "0 4px 6px -1px rgba(0,0,0,0.2)",
                    }}
                  >
                    <div style={{ marginBottom: "16px" }}>
                      <h4
                        style={{
                          margin: "0 0 4px 0",
                          fontSize: "1.1rem",
                          color: "#fff",
                        }}
                      >
                        {user.nombre}
                      </h4>
                      <p
                        style={{
                          margin: 0,
                          fontSize: "0.85rem",
                          color: "#94a3b8",
                          wordBreak: "break-all",
                        }}
                      >
                        {user.email}
                      </p>
                    </div>

                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        gap: "12px",
                        marginBottom: "20px",
                      }}
                    >
                      <div>
                        <span
                          style={{
                            fontSize: "0.75rem",
                            color: "#64748b",
                            display: "block",
                            marginBottom: "4px",
                            fontWeight: "600",
                          }}
                        >
                          ANVERSO
                        </span>
                        <a
                          href={`https://micontenidohot.com/uploads/${user.carnet_anverso}`}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <img
                            src={`https://micontenidohot.com/uploads/${user.carnet_anverso}`}
                            alt="Anverso ID"
                            style={{
                              width: "100%",
                              height: "95px",
                              objectFit: "cover",
                              borderRadius: "8px",
                              border: "1px solid #334155",
                              cursor: "zoom-in",
                            }}
                          />
                        </a>
                      </div>
                      <div>
                        <span
                          style={{
                            fontSize: "0.75rem",
                            color: "#64748b",
                            display: "block",
                            marginBottom: "4px",
                            fontWeight: "600",
                          }}
                        >
                          REVERSO
                        </span>
                        <a
                          href={`https://micontenidohot.com/uploads/${user.carnet_reverso}`}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <img
                            src={`https://micontenidohot.com/uploads/${user.carnet_reverso}`}
                            alt="Reverso ID"
                            style={{
                              width: "100%",
                              height: "95px",
                              objectFit: "cover",
                              borderRadius: "8px",
                              border: "1px solid #334155",
                              cursor: "zoom-in",
                            }}
                          />
                        </a>
                      </div>
                    </div>

                    <button
                      onClick={() => manejarAccion(user.id, "aprobar_usuario")}
                      style={{
                        marginTop: "auto",
                        width: "100%",
                        padding: "12px",
                        background: "#22c55e",
                        color: "#fff",
                        border: "none",
                        borderRadius: "10px",
                        cursor: "pointer",
                        fontWeight: "700",
                        fontSize: "0.9rem",
                        boxShadow: "0 4px 12px rgba(34, 197, 94, 0.2)",
                      }}
                    >
                      Aprobar Mayoría de Edad ✓
                    </button>
                  </div>
                ))}
              </div>
            )}
          </section>
        )}

        {/* SECCIÓN ANUNCIOS */}
        {pestanaActiva === "anuncios" && (
          <section>
            {anuncios.length === 0 ? (
              <div
                style={{
                  textAlign: "center",
                  padding: "60px 20px",
                  background: "#0f172a",
                  borderRadius: "16px",
                  border: "1px dashed #334155",
                }}
              >
                <p style={{ color: "#64748b", fontSize: "1rem", margin: 0 }}>
                  ✨ Limpio. No hay anuncios pendientes de moderación en la
                  cola.
                </p>
              </div>
            ) : (
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr",
                  gap: "24px",
                }}
              >
                {anuncios.map((ad) => {
                  /*
|--------------------------------------------------------------------------
| FECHAS
|--------------------------------------------------------------------------
*/

                  const convertirFecha = (fecha) => {
                    if (!fecha) return null;

                    const valor = String(fecha).trim();

                    if (!valor) return null;

                    const fechaConvertida = new Date(
                      valor.includes("T") ? valor : valor.replace(" ", "T")
                    );

                    return isNaN(fechaConvertida.getTime())
                      ? null
                      : fechaConvertida;
                  };

                  const ahora = new Date();

                  const fechaPlan = convertirFecha(ad.fecha_vencimiento_plan);
                  const fechaTop = convertirFecha(ad.fecha_vencimiento_top);
                  const fechaDestacado = convertirFecha(
                    ad.fecha_vencimiento_destacado
                  );

                  const planActivo =
                    fechaPlan && fechaPlan.getTime() > ahora.getTime();

                  const topActivo =
                    fechaTop && fechaTop.getTime() > ahora.getTime();

                  const destacadoActivo =
                    fechaDestacado &&
                    fechaDestacado.getTime() > ahora.getTime();

                  /*
|--------------------------------------------------------------------------
| IDENTIFICAR PLAN PRINCIPAL
|--------------------------------------------------------------------------
*/

                  const planPrincipal = String(ad.plan || "").toLowerCase();

                  const esPlan30 = planPrincipal === "mes";

                  /*
|--------------------------------------------------------------------------
| IDENTIFICAR QUÉ SE ESTÁ SOLICITANDO
|--------------------------------------------------------------------------
|
| tipo_plan representa la compra que está esperando aprobación.
|
*/

                  const tipoCompra = String(ad.tipo_plan || "").toLowerCase();

                  const solicitaTop = tipoCompra === "top_7dias";

                  const solicitaDestacado = tipoCompra === "destacado_7dias";

                  const solicitaVip = tipoCompra === "vip_30dias";

                  const solicitaPlan30 =
                    tipoCompra === "mes_30dias" ||
                    tipoCompra === "mes" ||
                    tipoCompra === "30_dias";

                  const solicitaBasico =
                    tipoCompra === "semana_7dias" ||
                    tipoCompra === "semana" ||
                    tipoCompra === "basico_7dias";

                  /*
|--------------------------------------------------------------------------
| INFORMACIÓN DEL PLAN PRINCIPAL
|--------------------------------------------------------------------------
*/

                  let nombrePlanPrincipal = "Plan Básico 7 Días";
                  let montoPlanPrincipal = "19";

                  let estiloPlanPrincipal = {
                    bg: "rgba(100, 116, 139, 0.2)",
                    text: "#94a3b8",
                  };

                  if (planPrincipal === "mes") {
                    nombrePlanPrincipal = "Plan 30 Días";
                    montoPlanPrincipal = "59";

                    estiloPlanPrincipal = {
                      bg: "rgba(16, 185, 129, 0.2)",
                      text: "#34d399",
                    };
                  }

                  /*
|--------------------------------------------------------------------------
| VIP
|--------------------------------------------------------------------------
|
| VIP es un plan especial de 30 días.
|
*/

                  if (solicitaVip || tipoCompra === "vip_30dias") {
                    nombrePlanPrincipal = "VIP 30 Días";
                    montoPlanPrincipal = "159";

                    estiloPlanPrincipal = {
                      bg: "rgba(220, 38, 38, 0.2)",
                      text: "#f87171",
                    };
                  }

                  /*
|--------------------------------------------------------------------------
| RENDER
|--------------------------------------------------------------------------
*/

                  return (
                    <div
                      key={ad.id}
                      style={{
                        background: "#0f172a",
                        padding: "20px",
                        borderRadius: "16px",
                        border: "1px solid #1e293b",
                        display: "flex",
                        gap: "16px",
                        flexWrap: "wrap",
                        width: "100%",
                        boxSizing: "border-box",
                      }}
                    >
                      {/* ================================================================
        FOTOS
    ================================================================= */}

                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "12px",
                          width: "120px",
                          flexShrink: 0,
                        }}
                      >
                        <div>
                          <span
                            style={{
                              fontSize: "0.65rem",
                              color: "#64748b",
                              display: "block",
                              marginBottom: "2px",
                              fontWeight: "600",
                            }}
                          >
                            ANUNCIO
                          </span>

                          <img
                            src={`https://micontenidohot.com/${ad.photo_url}`}
                            alt="Anuncio Principal"
                            style={{
                              width: "100%",
                              height: "100px",
                              objectFit: "cover",
                              borderRadius: "8px",
                              border: "1px solid #1e293b",
                            }}
                          />
                        </div>

                        <div>
                          <span
                            style={{
                              fontSize: "0.65rem",
                              color: "#22c55e",
                              display: "block",
                              marginBottom: "2px",
                              fontWeight: "600",
                            }}
                          >
                            COMPROBANTE QR
                          </span>

                          {ad.comprobante_url ? (
                            <a
                              href={`https://micontenidohot.com/${ad.comprobante_url}`}
                              target="_blank"
                              rel="noreferrer"
                            >
                              <img
                                src={`https://micontenidohot.com/${ad.comprobante_url}`}
                                alt="Comprobante Pago QR"
                                style={{
                                  width: "100%",
                                  height: "100px",
                                  objectFit: "cover",
                                  borderRadius: "8px",
                                  border: "2px solid #22c55e",
                                  cursor: "zoom-in",
                                }}
                              />
                            </a>
                          ) : (
                            <div
                              style={{
                                width: "100%",
                                height: "100px",
                                background: "#1e293b",
                                borderRadius: "8px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontSize: "0.7rem",
                                color: "#94a3b8",
                                textAlign: "center",
                                padding: "4px",
                                boxSizing: "border-box",
                              }}
                            >
                              Sin comprobante
                            </div>
                          )}
                        </div>
                      </div>

                      {/* ================================================================
        INFORMACIÓN
    ================================================================= */}

                      <div
                        style={{
                          flex: "1",
                          display: "flex",
                          flexDirection: "column",
                          minWidth: "280px",
                        }}
                      >
                        {/* ==============================================================
          NOMBRE + PLANES
      =============================================================== */}

                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "flex-start",
                            gap: "15px",
                            marginBottom: "10px",
                          }}
                        >
                          <h4
                            style={{
                              margin: 0,
                              fontSize: "1.2rem",
                              color: "#fff",
                              fontWeight: "700",
                            }}
                          >
                            {ad.nic}

                            <span
                              style={{
                                fontSize: "0.9rem",
                                color: "#94a3b8",
                                fontWeight: "normal",
                              }}
                            >
                              {" "}
                              ({ad.age} años)
                            </span>
                          </h4>

                          {/* ============================================================
            ETIQUETAS
        ============================================================= */}

                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "flex-end",
                              gap: "5px",
                              flexShrink: 0,
                            }}
                          >
                            {/* PLAN PRINCIPAL */}

                            <span
                              style={{
                                fontSize: "0.75rem",
                                background: estiloPlanPrincipal.bg,
                                color: estiloPlanPrincipal.text,
                                padding: "4px 10px",
                                borderRadius: "20px",
                                fontWeight: "800",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {nombrePlanPrincipal} ({montoPlanPrincipal} Bs)
                            </span>

                            {/* ==========================================================
              SOLICITUD DE TOP
          =========================================================== */}

                            {solicitaTop && (
                              <span
                                style={{
                                  fontSize: "0.72rem",
                                  background: "rgba(37, 99, 235, 0.18)",
                                  color: "#60a5fa",
                                  padding: "4px 10px",
                                  borderRadius: "20px",
                                  fontWeight: "800",
                                  whiteSpace: "nowrap",
                                  border: "1px solid rgba(96, 165, 250, 0.25)",
                                }}
                              >
                                ⭐ TOP 7 DÍAS — 35 Bs
                              </span>
                            )}

                            {/* ==========================================================
              SOLICITUD DE DESTACADO
          =========================================================== */}

                            {solicitaDestacado && (
                              <span
                                style={{
                                  fontSize: "0.72rem",
                                  background: "rgba(217, 119, 6, 0.18)",
                                  color: "#fbbf24",
                                  padding: "4px 10px",
                                  borderRadius: "20px",
                                  fontWeight: "800",
                                  whiteSpace: "nowrap",
                                  border: "1px solid rgba(251, 191, 36, 0.25)",
                                }}
                              >
                                🔥 DESTACADO 7 DÍAS — 29 Bs
                              </span>
                            )}

                            {/* ==========================================================
              SOLICITUD VIP
          =========================================================== */}

                            {solicitaVip && (
                              <span
                                style={{
                                  fontSize: "0.72rem",
                                  background: "rgba(220, 38, 38, 0.18)",
                                  color: "#f87171",
                                  padding: "4px 10px",
                                  borderRadius: "20px",
                                  fontWeight: "800",
                                  whiteSpace: "nowrap",
                                  border: "1px solid rgba(248, 113, 113, 0.25)",
                                }}
                              >
                                👑 VIP 30 DÍAS — 159 Bs
                              </span>
                            )}
                          </div>
                        </div>

                        {/* ==============================================================
          ESTADO DE LOS POTENCIADORES
      =============================================================== */}

                        {(topActivo || destacadoActivo) && (
                          <div
                            style={{
                              display: "flex",
                              gap: "7px",
                              flexWrap: "wrap",
                              marginBottom: "10px",
                            }}
                          >
                            {topActivo && (
                              <span
                                style={{
                                  fontSize: "0.68rem",
                                  background: "rgba(37, 99, 235, 0.12)",
                                  color: "#60a5fa",
                                  padding: "3px 8px",
                                  borderRadius: "8px",
                                  fontWeight: "700",
                                }}
                              >
                                ⭐ TOP ACTIVO
                              </span>
                            )}

                            {destacadoActivo && (
                              <span
                                style={{
                                  fontSize: "0.68rem",
                                  background: "rgba(217, 119, 6, 0.12)",
                                  color: "#fbbf24",
                                  padding: "3px 8px",
                                  borderRadius: "8px",
                                  fontWeight: "700",
                                }}
                              >
                                🔥 DESTACADO ACTIVO
                              </span>
                            )}
                          </div>
                        )}

                        {/* ==============================================================
          DATOS
      =============================================================== */}

                        <p
                          style={{
                            margin: "0 0 6px 0",
                            fontSize: "0.85rem",
                            color: "#cbd5e1",
                          }}
                        >
                          📍 {ad.location} | 📞 {ad.phone}
                        </p>

                        <p
                          style={{
                            margin: "0 0 16px 0",
                            fontSize: "0.75rem",
                            color: "#94a3b8",
                            lineHeight: "1.4",
                            background: "#090d16",
                            padding: "8px 12px",
                            borderRadius: "8px",
                            border: "1px solid #1e293b",
                            maxHeight: "135px",
                            overflowY: "auto",
                          }}
                        >
                          {ad.description}
                        </p>

                        {/* ==============================================================
          BOTÓN APROBAR
      =============================================================== */}

                        <button
                          onClick={() =>
                            manejarAccion(ad.id, "aprobar_anuncio")
                          }
                          style={{
                            marginTop: "auto",
                            width: "100%",
                            padding: "10px 14px",
                            background: "#ff2c55",
                            color: "#fff",
                            border: "none",
                            borderRadius: "10px",
                            cursor: "pointer",
                            fontWeight: "700",
                            fontSize: "0.88rem",
                            boxShadow: "0 4px 12px rgba(255, 44, 85, 0.3)",
                            transition: "all 0.2s",
                          }}
                        >
                          Aprobar Pago y Activar Plan ✓
                        </button>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </section>
        )}
      </main>
    </div>
  );
}

export default PanelAdmin;
